var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.244 14.612L13 13.822l-1.244.79c-.225.143-.511-.057-.454-.318l.336-1.514-1.134-1.034c-.193-.176-.084-.497.176-.52l1.477-.132.565-1.403c.1-.25.456-.25.556 0l.565 1.403 1.477.132c.26.023.369.344.176.52l-1.134 1.034.336 1.514c.057.26-.229.461-.454.318z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4v2c-.552 0-1 .448-1 1s.448 1 1 1v3c-.552 0-1 .448-1 1s.448 1 1 1v3c-.552 0-1 .448-1 1s.448 1 1 1v2c0 1.105.895 2 2 2h13c1.105 0 2-.895 2-2V4c0-1.105-.895-2-2-2H6c-1.105 0-2 .895-2 2zm15 0H6v2c.552 0 1 .448 1 1s-.448 1-1 1v3c.552 0 1 .448 1 1s-.448 1-1 1v3c.552 0 1 .448 1 1s-.448 1-1 1v2h13V4z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradebook);
export default __webpack_public_path__ + "static/media/gradebook.ee19a2c4817ba9772a85a51bf1ee67ad.svg";
export { ForwardRef as ReactComponent };